import { createApp, watch } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './plugins/i18n'

// 引入全局样式 解决 1px 问题
import './assets/global.css'
import './assets/styles/app-shell.css'
import './assets/styles/legacy-layout.css'
import './assets/styles/pixso-theme.css'

watch(
  () => i18n.global.locale.value,
  (locale) => {
    document.title = i18n.global.t('App.title')
    document.documentElement.lang = locale === 'en' ? 'en' : 'zh-CN'
    document.documentElement.dataset.locale = locale
  },
  { immediate: true }
)

createApp(App).use(store).use(router).use(i18n).mount('#app')
